import { render, staticRenderFns } from "./InputScale.vue?vue&type=template&id=b72f9944&scoped=true&"
import script from "./InputScale.vue?vue&type=script&lang=js&"
export * from "./InputScale.vue?vue&type=script&lang=js&"
import style0 from "./InputScale.vue?vue&type=style&index=0&id=b72f9944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f9944",
  null
  
)

export default component.exports